import Type, {} from 'typebox';
export const RateLimitConfigSchema = Type.Object({
    user: Type.Object({
        maxPoints: Type.Number({ default: 4 }),
        duration: Type.Number({ default: 15 }),
    }),
    /**
     * Automatic mode, like a car's climate control: set the speed, and
     * admin-api moves `user` every 30 seconds to keep the chat near it. See
     * `@pin/shared/autoRateLimit.redis`.
     */
    auto: Type.Optional(Type.Object({
        messagesPerMinute: Type.Number({ minimum: 1 }),
    })),
});
const ChatStatusSchema = Type.Union([Type.Literal('open'), Type.Literal('closed'), Type.Literal('broken')], { default: 'open' });
export const ChatConfigSchema = Type.Object({
    status: ChatStatusSchema,
});
export const ConfigSchema = Type.Object({
    chat: ChatConfigSchema,
    rateLimit: RateLimitConfigSchema,
});
/**
 * How many are in the chat, across every server. `authenticated` is the
 * number of distinct logged-in accounts, `anonymous` the number of sockets
 * without a login, `total` their sum. See `@pin/shared/userCount.redis`.
 */
export const UserCountSchema = Type.Object({
    total: Type.Integer({ minimum: 0 }),
    authenticated: Type.Integer({ minimum: 0 }),
    anonymous: Type.Integer({ minimum: 0 }),
});
//# sourceMappingURL=common.js.map